import React from "react";
import { useTranslation } from 'react-i18next';
import Product from "../Components/product/Product";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import seoData from "../data/seoData.json";

function ProductPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = seoData[currentLang]?.products || seoData.en.products;

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/urunlerimiz"
      />
      <TopBar />
      <Spacer /><Spacer />
      <Product />
    </>
  );
}

export default ProductPage;
